module.exports = __webpack_public_path__ + "img/Incoming_call.c42af315.svg";